import { instanceWithAuth } from './index'

// 홈화면 알림 아이콘의 알림개수
function getAlarmCount() {
  return instanceWithAuth.get('/mobile/alarm/count')
}

// 알림함 API - 전체 /mobile/alarm/pageNo
function getAllAlarm(page) {
  return instanceWithAuth.get('/mobile/alarm')
}

// systemId별 /mobile/alarm/systemId/pageNo
function getAlarm(page) {
  return instanceWithAuth.get('/mobile/alarm/' + page)
}

function clearAlarm() {
  return instanceWithAuth.patch('/mobile/alarm')
}

// 알림 읽음 처리
function updateAlarm(pushId) {
  return instanceWithAuth.get('/mobile/alarm/read/' + pushId)
}

// 알림 상세
function getAlarmDetail(alarmData) {
  return instanceWithAuth.get('/mobile/alarm/detail', {
    params: {
      system: alarmData.system,
      systemId: alarmData.systemId,
    },
  })
}

export {
  getAlarmCount,
  clearAlarm,
  getAllAlarm,
  getAlarm,
  updateAlarm,
  getAlarmDetail,
}
